export const inputEvents = "change keydown paste input"
